import { createContext, FC, ReactNode } from 'react';

export const SsrContext = createContext(true);

export const BelowTheFold: FC<{ children: ReactNode }> = ({ children }) => (
  <SsrContext.Provider value={false}>{children}</SsrContext.Provider>
);
